import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { resolveUrl } from "../../lib/media";

const slugOf = (ed) => ed?.id || ed?.year;

// Edition-scoped header shared by the Edition page and the Palmarès page.
// Keeps the visitor INSIDE the current edition (Films / Palmarès carry the year)
// and always offers an explicit "← Retour au Festival" to leave the edition.
// - onFilms: optional handler (edition page smooth-scrolls to its films section);
//   when absent, "Films" links to the edition page for the current year.
export const ArchiveHeader = ({ brand = {}, edition, onApply, onFilms, active }) => {
  const year = edition?.year;
  const slug = slugOf(edition);
  const link = "text-[11px] tracking-[0.1em] md:tracking-[0.18em] uppercase text-white/70 hover:text-electric transition-colors whitespace-nowrap";
  const on = "text-electric font-semibold";
  return (
    <header className="festival-universe fixed top-0 inset-x-0 z-50 bg-[#050505]/90 backdrop-blur border-b border-white/10" data-testid="archive-header">
      <div className="max-w-6xl mx-auto px-4 md:px-12 h-16 md:h-20 flex items-center justify-between gap-3">
        <Link to="/festival" className="flex items-center gap-2 shrink-0" data-testid="archive-logo">
          {brand.logo ? <img src={resolveUrl(brand.logo)} alt={brand.name || "Karams"} className="h-7 md:h-9 w-auto" /> : <span className="fx-nav font-serif text-lg text-white">{brand.name || "Karams Festival"}</span>}
        </Link>
        <nav className="fx-nav flex items-center gap-2.5 md:gap-7 overflow-x-auto" data-testid="archive-nav" style={{ scrollbarWidth: "none" }}>
          <span className="hidden md:inline-flex text-[11px] tracking-[0.18em] uppercase text-electric font-semibold whitespace-nowrap" data-testid="archive-nav-edition">Édition {year}</span>
          {onFilms
            ? <button onClick={onFilms} className={`${link} ${active === "films" ? on : ""}`} data-testid="archive-nav-films">Films</button>
            : <Link to={`/festival/edition/${slug}`} className={`${link} ${active === "films" ? on : ""}`} data-testid="archive-nav-films">Films</Link>}
          <Link to={`/festival/palmares?year=${year}`} className={`${link} ${active === "palmares" ? on : ""}`} data-testid="archive-nav-palmares">Palmarès</Link>
          <button onClick={onApply} className={link} data-testid="archive-nav-participer">Participer</button>
          <Link to="/festival" className="text-[11px] tracking-[0.1em] md:tracking-[0.18em] uppercase text-electric hover:text-white transition-colors whitespace-nowrap inline-flex items-center gap-1.5 shrink-0" data-testid="archive-nav-retour"><ArrowLeft size={13} /> <span className="sm:hidden">Festival</span><span className="hidden sm:inline">Retour au Festival</span></Link>
        </nav>
      </div>
    </header>
  );
};
